import { JsonObject, JsonProperty } from 'json2typescript';
import { EmptyControl } from '@hvlng/framework-bff/core';

import { EnumBpmnProcessType, EnumBpmnProcessTypeConverter } from './enum-bpmn-process-type';
import {
    EnumPersonalDataApprovalStatus,
    EnumPersonalDataApprovalStatusConverter,
} from './enum-personal-data-approval-status';

@JsonObject('KovanHrCommonApproveModel')
export class CommonApproveModel {
    @EmptyControl()
    @JsonProperty('taskId', String, true)
    taskId: string = null;

    @EmptyControl()
    @JsonProperty('id', Number, true)
    id: number = null;

    @JsonProperty('processType', EnumBpmnProcessTypeConverter, true)
    processType: EnumBpmnProcessType = null;

    @JsonProperty('personalDataApprovalStatus', EnumPersonalDataApprovalStatusConverter, true)
    personalDataApprovalStatus: EnumPersonalDataApprovalStatus = null;

    @EmptyControl()
    @JsonProperty('message', String, true)
    message: string = null;

    @EmptyControl()
    @JsonProperty('completingPersonUserName', String, true)
    completingPersonUserName: string = null;
}
